<script setup lang="ts">
  import { useUser } from '@gat-ship/user'
  import type {
    ComboboxFieldItem,
    ComboboxFieldProps
  } from '@gat-ship/vue-components'
  import { type Database } from '@gat-ship/types'
  import { computed } from 'vue'
  import { testIds } from '@gat-ship/types'
  import { IconDatabase } from '@gat-ship/icons'
  import { ComboboxField } from '@gat-ship/vue-components'

  export interface SelectDatabaseProps extends Omit<
    ComboboxFieldProps,
    'items' | 'modelValue'
  > {
    items?: Database[]
  }

  const props = defineProps<SelectDatabaseProps>()

  const selectedDatabase = defineModel<Database['id'] | undefined>({
    required: true
  })

  const isOpen = defineModel<boolean>('open', { default: false })

  const user = useUser()

  const _items = computed(() => {
    if (!props.items) {
      const result: ComboboxFieldItem<Database>[] =
        user.databases.value.all.map((i) => ({
          title: i.name,
          value: i.id,
          searchValue: i.name,
          metaData: i
        }))
      return result
    }
    const result: ComboboxFieldItem<Database>[] =
      props.items.map((i) => ({
        title: i.name,
        value: i.id,
        searchValue: i.name,
        metaData: i
      })) ?? []
    return result
  })
</script>
<template>
  <ComboboxField
    v-bind="props"
    v-model="selectedDatabase"
    v-model:open="isOpen"
    :data-testid="props.dataTestid ?? testIds.common.select.database"
    :items="_items"
    placeholder="Select Database"
  >
    <div
      v-if="selectedDatabase"
      class="flex items-center gap-2 overflow-hidden"
    >
      <icon-database class="size-4" />
      <div class="truncate">
        {{ _items.find((i) => i.value === selectedDatabase)?.title }}
      </div>
    </div>
    <template #item="{ item }">
      <div class="flex grow items-center gap-2">
        <icon-database class="size-4" />
        <div>{{ item.title }}</div>
      </div>
    </template>
  </ComboboxField>
</template>
